// import fetch from 'isomorphic-fetch';
import ApiService from '../../util/api';

export const ActionTypes = {
  REQUEST_SEARCH_CARD_SUITES: 'zola/cards/card_catalog/REQUEST_SEARCH_CARD_SUITES',
  RECEIVE_SEARCH_CARD_SUITES: 'zola/cards/card_catalog/RECEIVE_SEARCH_CARD_SUITES',
  REQUEST_CARD_SUITE: 'zola/cards/card_catalog/REQUEST_CARD_SUITE',
  RECEIVE_CARD_SUITE: 'zola/cards/card_catalog/RECEIVE_CARD_SUITE',
  REQUEST_CARD: 'zola/cards/card_catalog/REQUEST_CARD',
  RECEIVE_CARD: 'zola/cards/card_catalog/RECEIVE_CARD',
  UPDATE_SEARCH_FILTERS: 'zola/cards/card_catalog/UPDATE_SEARCH_FILTER',
  RESET_SEARCH_FILTERS: 'zola/cards/card_catalog/RESET_SEARCH_FILTERS',
  SET_INITIAL_VARIATION_COLOR: 'zola/cards/card_catalog/SET_INITIAL_VARIATION_COLOR',
  UPDATE_VARIATION_OPTIONS: 'zola/cards/card_catalog/UPDATE_VARIATION_OPTIONS',
  REQUEST_THEME_GROUPS_FOR_CARD: 'zola/cards/card_catalog/REQUEST_THEME_GROUPS_FOR_CARD',
  RECEIVE_THEME_GROUPS_FOR_CARD: 'zola/cards/card_catalog/RECEIVE_THEME_GROUPS_FOR_CARD'
};

function requestSearchCardSuites() {
  return {
    type: ActionTypes.REQUEST_SEARCH_CARD_SUITES
  };
}

function receiveSearchCardSuites(json) {
  return {
    type: ActionTypes.RECEIVE_SEARCH_CARD_SUITES,
    payload: {
      cardSuites: json
    }
  };
}

function requestCardSuite() {
  return {
    type: ActionTypes.REQUEST_CARD_SUITE
  };
}

function receiveCardSuite(json) {
  return {
    type: ActionTypes.RECEIVE_CARD_SUITE,
    payload: {
      cardSuite: json
    }
  };
}

function requestCard() {
  return {
    type: ActionTypes.REQUEST_CARD
  };
}

function receiveCard(json) {
  return {
    type: ActionTypes.RECEIVE_CARD,
    payload: {
      card: json
    }
  };
}

function requestThemeGroupsForCard() {
  return {
    type: ActionTypes.REQUEST_THEME_GROUPS_FOR_CARD
  };
}

function receiveThemeGroupsForCard(cardUUID, json) {
  return {
    type: ActionTypes.RECEIVE_THEME_GROUPS_FOR_CARD,
    payload: {
      cardUUID,
      themeGroups: json
    }
  };
}

export function updateSearchFilters(key, value) {
  return {
    type: ActionTypes.UPDATE_SEARCH_FILTERS,
    payload: { key, value }
  };
}

export function resetSearchFilters() {
  return {
    type: ActionTypes.RESET_SEARCH_FILTERS
  };
}

export function setInitialVariationColor(color) {
  return {
    type: ActionTypes.SET_INITIAL_VARIATION_COLOR,
    payload: { color }
  };
}

export function updateVariationOptions(key, value) {
  return {
    type: ActionTypes.UPDATE_VARIATION_OPTIONS,
    payload: { key, value }
  };
}

export function searchCardSuites() {
  return (dispatch, getState) => {
    const { filters, initial } = getState().cards.cardCatalog;
    const requestBody = {
      offset: initial ? 0 : filters.offset + filters.limit,
      limit: filters.limit,
      active_only: filters.active_only,
      lead_card_type: filters.lead_card_type,
      color: filters.color,
      has_foil: filters.has_foil,
      has_custom_photo: filters.has_custom_photo,
    };
    dispatch(requestSearchCardSuites());
    return ApiService.post('/web-api/v1/card-catalog/search', requestBody)
      .then(json => dispatch(receiveSearchCardSuites(json)));
  };
}

export function getCardSuite(suiteUUID) {
  return (dispatch) => {
    dispatch(requestCardSuite());
    return ApiService.get(`/web-api/v1/card-catalog/suites/${suiteUUID}`)
      .then(json => dispatch(receiveCardSuite(json)));
  };
}

export function getCard() {
  const cardUUID = 'db50de3b-521e-4f44-ad82-6b5136cfc04b';
  return (dispatch) => {
    dispatch(requestCard());
    return ApiService.get(`/web-api/v1/card-catalog/${cardUUID}`)
      .then(json => dispatch(receiveCard(json)));
  };
}

export function getCardByVariationUUID(variationUUID) {
  return (dispatch) => {
    dispatch(requestCard());
    return ApiService.get(`web-api/v1/card-catalog/variations/${variationUUID}/card`)
      .then(json => dispatch(receiveCard(json)));
  };
}

export function getThemeGroupsForCard(cardUUID) {
  return (dispatch) => {
    dispatch(requestThemeGroupsForCard());
    return ApiService.get(`/web-api/v1/card-catalog/${cardUUID}/themes`)
      .then(json => dispatch(receiveThemeGroupsForCard(cardUUID, json)));
  };
}



// WEBPACK FOOTER //
// ./src/cards/actions/cardCatalogActions.js